import neverLandUtils from "../utils/NeverLandUtils";

export const LOGIN_CODE = 'lc*'
export const USER_INFO = 'ui*'
export const USER_CONFIG = 'uc'

export const TODAY = new Date().toISOString();
let _thisConfig = null;

export function _getResourcePath(_url) {
  let currentUrl = window.location.href;

  if (currentUrl.includes('.com')) {
    const newUrl = new URL(_url);
    newUrl.hostname = currentUrl.replace('http://', '').replace('https://', '').split("/")[0]; // 도메인 부분만 대체

    _url = newUrl.href;
  }
  return _url;
}

class MyAccountInfo {
  //로컬스토리지 저장되어있는 정보 가져오기
  isLogin() {
    return neverLandUtils.commons.load(LOGIN_CODE);
  }

  accountId() {
    return neverLandUtils.commons.load(USER_INFO)?.userId || -1;
  }

  accountNickName() {
    return neverLandUtils.commons.load(USER_INFO)?.nickName || -1;
  }

  accountLoginCode() {
    const loginCode = neverLandUtils.commons.load(LOGIN_CODE) || "none";
    return loginCode.replace(/"/g, '');
  }

  getStoreCode() {
    let addData = neverLandUtils.commons.load(USER_INFO)?.additionalData || [];
    if (addData.length === 0)
      return '?';

    for (let data of addData) {
      if (data.name === 'storeCode') {
        return data.value;
      }
    }
    return '?';
  }

  getDefaultStore() {
    return neverLandUtils.commons.load(USER_INFO)?.defaultStore;
  }

  makeGetRequest(api) {
    return api + `?userId=${this.accountId()}&sessionCode=${this.accountSessionCode()}`;
  }

  makeJson() {
    return neverLandUtils.commons.load(USER_INFO);
  }


  login(userInfo) {
    // if(Environment.isTest) {
    if (userInfo.userTag) {
      if (userInfo.userTag.includes('#store')) {
        userInfo.isStore = true;
      }
      if (userInfo.userTag.includes('#admin')) {
        userInfo.isAdmin = true;
        let index = userInfo.userTag.indexOf('#admin:');
        if (index > 5) {
          let level = userInfo.userTag.substring(index + 7);
          userInfo.adminLevel = level.split('#')[0].trim();
        } else {
          userInfo.adminLevel = "normal";
        }
      }
    }


    if (userInfo.additionalData && userInfo.additionalData.length > 0) {
      for (let data of userInfo.additionalData) {
        if (data.name === 'myDefaultStoreCode') {
          userInfo.defaultStore = data.value;
        }
        if (data.name === 'myDefaultStoreState') {
          userInfo.isDefaultStoreConfirmed = data.value === "confirmed";
        }
      }
    }
    neverLandUtils.commons.save(USER_INFO, userInfo);
  }

  getProfileImage() {
    let id = accountInfo.accountId();

    if (id === -1) {
      return _getResourcePath("http://teamneverland.com/resources/img/user-profiles/00001.png");
    }
    id = id % 3;
    if (id === 0) {
      return _getResourcePath("http://teamneverland.com/resources/img/user-profiles/00002.png");
    }
    if (id === 1) {
      return _getResourcePath("http://teamneverland.com/resources/img/user-profiles/00003.png");
    }
    if (id === 2) {
      return _getResourcePath("http://teamneverland.com/resources/img/user-profiles/00004.png");
    }
    return _getResourcePath("https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80");
  }


  activateUsePrinting() {
    neverLandUtils.commons.save("activateUsePrinting", true);
  }

  usePrinting() {
    return neverLandUtils.commons.load("activateUsePrinting") === true;
  }


  getUserConfig() {
    if (_thisConfig === null) {
      _thisConfig = neverLandUtils.commons.load(USER_CONFIG);

      if (_thisConfig === null) {
        _thisConfig = {
          options: {},
          isOn: (key, defaultValue) => {
            if (_thisConfig) {
              return _thisConfig.options !== undefined && _thisConfig.options[key] !== undefined ? _thisConfig.options[key] : defaultValue;
            }
            return defaultValue
          },
          setOptionOn: (key, newValue) => {
            if (_thisConfig) {
              if (_thisConfig.options === undefined) _thisConfig.options = {};
              _thisConfig.options[key] = newValue;
              this.storeUserConfig();

            }
            return newValue;
          }
        };
        this.storeUserConfig();
      } else {
        _thisConfig.isOn = (key, defaultValue) => {
          if (_thisConfig) {
            return _thisConfig.options !== undefined && _thisConfig.options[key] !== undefined ? _thisConfig.options[key] : defaultValue;
          }
          return defaultValue
        };
        _thisConfig.setOptionOn = (key, newValue) => {
          if (_thisConfig) {
            if (_thisConfig.options === undefined) _thisConfig.options = {};
            _thisConfig.options[key] = newValue;
            this.storeUserConfig();

          }
          return newValue;
        };
      }
    }
    // TODO : DB에서 회원설정 생성해서 백엔드 RESTFUL로 정보 가져오기가 필요할까? 차후 고민하기 (로그인할때?)
    return _thisConfig;
  }

  updateDefaultStoreCode(storeCode) {
    let userInfo = neverLandUtils.commons.load(USER_INFO);
    userInfo.defaultStore = storeCode;
    neverLandUtils.commons.save(USER_INFO, userInfo);
  }

  isDefaultStoreConfirmed() {
    return neverLandUtils.commons.load(USER_INFO).isDefaultStoreConfirmed;
  }

  storeUserConfig() {
    neverLandUtils.commons.save(USER_CONFIG, _thisConfig);
  }

  getAdditionalData(key, defaultValue) {
    let userInfo = neverLandUtils.commons.load(USER_INFO);
    if (userInfo.additionalData && userInfo.additionalData.length > 0) {
      for (let data of userInfo.additionalData) {
        if (data.name === key) {
          return data.value;
        }
      }
    }
    return defaultValue;
  }

  isExtServiceUsable(serviceName) {
    let storeLevel = this.getAdditionalData('storeLevel', '0');

    if (storeLevel === '0' || storeLevel === '1' || storeLevel === 'null' || storeLevel === null)
      return false;
    return true;
  }

  getExtServiceName(serviceName) {
    if (serviceName === 'bona')
      return '보나스포츠(제휴업체)';
    return '알수없음';
  }

  extServiceAccount(serviceName) {
    let accountName = this.getAdditionalData(serviceName + ".accountName", '보나이메일/TEST');
    return '가입완료(ID:' + accountName + ')';
  }

  saveLastNavigation(path) {
    // <-- 마지막 페이지 위치 저장 -->
    if (path) {
      if (path.includes("excel_load"))
        return;
      if (path.includes("/resources/"))
        return;
    }
    neverLandUtils.commons.save("last_path", path);
  }

  loadLastNavigation() {
    // <-- 마지막 페이지 위치 가져오기 -->
    return neverLandUtils.commons.load("last_path");
  }

  getAlignDataList(key) {
    let value = neverLandUtils.commons.load("alignData");

    if (!value)
      return {};
    value = value[key];
    if (value)
      return value;
    return {};
  }

  saveAlignData(key, alignData) {
    let value = neverLandUtils.commons.load("alignData");
    if (!value) {
      value = {};
    }
    value[key] = alignData;

    neverLandUtils.commons.save("alignData", value);
  }

  isSpecial() {
    let user = neverLandUtils.commons.load(USER_INFO);
    if (user) {
      if (user.userLevel === null) return false;
      return user.userLevel.includes('special');
    }
    return false;
  }

  isDeveloper() {
    let user = neverLandUtils.commons.load(USER_INFO);
    if (user) {
      if (user.userLevel === null) return false;
      return user.userLevel.includes('dev');
    }
    return false;
  }
}


export const today = new Date();
export const month = today.getMonth();
export const day = today.getDate();
export const yesterday = new Date(today);
yesterday.setDate(today.getDate() - 1);

export const lastWeek = new Date(today);
lastWeek.setDate(today.getDate() - 7);

export const lastMonth = new Date(today);
lastMonth.setMonth(today.getMonth() - 1);


export const accountInfo = new MyAccountInfo();
